var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('portal',{attrs:{"to":"app-header"}},[_vm._v(" "+_vm._s(_vm.$t('bottleneckMachineDashboard'))+" ")]),_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }